export default "__VITE_ASSET__TInD7dHH__"